import React, { useState, useEffect, useRef } from "react";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
} from "react-icons/fa";
import "./Footer.css";
import axios from "axios";
import logoPartenaire from "../../assets/images/hubspot.jpg";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [footerVisible, setFooterVisible] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setFooterVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) observer.unobserve(footerRef.current);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("http://localhost:5000/api/newsletter", { email });
      alert("Inscription réussie !");
      setEmail("");
    } catch (error) {
      console.error(error);
      alert("Une erreur est survenue.");
    }
  };

  return (
    <footer
      ref={footerRef}
      className={`footer ${footerVisible ? "animate" : ""}`}
    >
      <div className="footer-map">
        <iframe
          title="Hoag Target – siège"
          src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d943.6684002357451!2d47.52683868178918!3d-18.901555892237315!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1sMadagascar%2C%20Antananarivo%2C%20MG%20Behoririka%20Behoririka%20IVD89!5e0!3m2!1sfr!2smg!4v1751020520298!5m2!1sfr!2smg"
          width="100%"
          height="300"
          style={{ border: 0, borderRadius: "10px" }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>

      <div className="footer-content">
        <div className="footer-column">
          <h4>Liens rapides</h4>
          <ul>
            <li>
              <a href="/">Accueil</a>
            </li>
            <li>
              <a href="/vision">Vision</a>
            </li>
            <li>
              <a href="/service">Services</a>
            </li>
            <li>
              <a href="/methodologie">Méthodologie</a>
            </li>
            <li>
              <a href="/contact">Contact</a>
            </li>
            <li>
              <a href="/apropos">À propos</a>
            </li>
          </ul>
        </div>

        {/* 🔽 Ajout de la section Nos Partenaires ici */}
        <div className="footer-column footer-partenaires">
          <h4>Nos Partenaires</h4>
          <div className="partenaire-logos">
            <div className="logo-box">
              <img src={logoPartenaire} alt="Logo Partenaire" />
            </div>
          </div>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li>Transformation digitale</li>
            <li>Outils numériques</li>
            <li>Employabilité & insertion pro</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Inscrivez-vous à notre newsletter</h4>
          <div className="footer-newsletter-form">
            <form onSubmit={handleSubmit}>
              <input
                className="email-input"
                type="email"
                placeholder="Entrez votre e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit">Envoyez</button>
            </form>
          </div>
          <div className="social-icons">
            <a
              href="https://www.facebook.com/HoagTarget"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/in/hoag-target-5b0723286/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link linkedin"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h4>Contacts</h4>
          <p>
            <FaMapMarkerAlt style={{ color: "#000", marginRight: "8px" }} />
            Lot IVD 89A Behoririka Antananarivo, Madagascar
          </p>
          <p>
            <FaEnvelope style={{ color: "#000", marginRight: "8px" }} />
            contact.hoagtarget@gmail.com
          </p>
          <p>
            <FaPhone style={{ color: "#000", marginRight: "8px" }} />
            +261 34 70 461 75
          </p>
          <p>
            <FaWhatsapp style={{ color: "#000", marginRight: "8px" }} />
            +1 240 273 5239
          </p>
        </div>
      </div>

      <div className="footer-bottom">© Copyright 2025 HOAG Target </div>
    </footer>
  );
};

export default Footer;
